import React from 'react';
import ReactDOM from 'react-dom/client';
import { TourProvider } from '@reactour/tour';
import App from './App';
import { TourNavigation } from './reacttour/OnboardingTourNavigation';
import { tourStyles } from './reacttour/styles/OnboardingTourStyles';
import TourAutoAdvanceListener from './reacttour/TourAutoAdvanceListener';
import './index.css';
import './mobile-utils.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Walkthroughs are started by the pages themselves (reacttour/useStudioTours.js), each with its own steps.
root.render(
  <React.StrictMode>
    <TourProvider
      steps={[]}
      scrollSmooth
      styles={tourStyles}
      components={{ Navigation: TourNavigation }}
      showCloseButton
      onClickMask={() => {}}
    >
      <TourAutoAdvanceListener />
      <App />
    </TourProvider>
  </React.StrictMode>
);
